export default "__VITE_ASSET__DRyWgxB1__"